class RecentlyViewedProducts {
  constructor() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    document.querySelectorAll(".remove-viewed-product").forEach((button) => {
      button.addEventListener("click", (e) => this.handleRemoveProduct(e));
    });

    const clearAllButton = document.getElementById("clear-all-viewed-products");
    if (clearAllButton) {
      clearAllButton.addEventListener("click", (e) => this.handleClearAll(e));
    }
  }

  handleRemoveProduct(e) {
    e.preventDefault();
    e.stopPropagation();

    const productId = e.target
      .closest(".remove-viewed-product")
      .getAttribute("data-product-id");
    const productElement = e.target.closest(".group, .swiper-slide");

    if (!productId) return;

    const button = e.target.closest(".remove-viewed-product");
    this.setLoadingState(button, true);

    fetch("/product/removeviewedproductajax", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        product_id: productId,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          this.animateRemoveProduct(productElement);
          this.checkAndHideSection();
          this.showSuccessMessage("Đã xóa sản phẩm khỏi danh sách đã xem");
        } else {
          throw new Error(data.error ? data.error.join(", ") : "Có lỗi xảy ra");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        this.showErrorMessage("Không thể xóa sản phẩm: " + error.message);
        this.setLoadingState(button, false);
      });
  }

  handleClearAll(e) {
    e.preventDefault();

    if (!confirm("Bạn có chắc chắn muốn xóa tất cả sản phẩm đã xem?")) {
      return;
    }

    const button = e.target;
    const originalText = button.innerHTML;
    this.setLoadingState(button, true, "Đang xóa...");

    fetch("/product/clearallviewedproductsajax", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          this.animateHideSection();
          this.showSuccessMessage("Đã xóa tất cả sản phẩm đã xem");
        } else {
          throw new Error(data.error ? data.error.join(", ") : "Có lỗi xảy ra");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        this.showErrorMessage(
          "Không thể xóa tất cả sản phẩm: " + error.message
        );
        this.setLoadingState(button, false, originalText);
      });
  }

  setLoadingState(button, isLoading, customText = null) {
    if (isLoading) {
      const spinnerSvg =
        '<svg class="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>';

      if (customText) {
        button.innerHTML = `${spinnerSvg}${customText}`;
      } else {
        button.innerHTML = spinnerSvg;
      }
      button.disabled = true;
    } else {
      const originalSvg =
        '<svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>';
      button.innerHTML = customText || originalSvg;
      button.disabled = false;
    }
  }

  animateRemoveProduct(productElement) {
    productElement.style.transition = "opacity 0.3s ease, transform 0.3s ease";
    productElement.style.opacity = "0";
    productElement.style.transform = "scale(0.8)";

    setTimeout(() => {
      productElement.remove();
    }, 300);
  }

  checkAndHideSection() {
    const remainingProducts = document.querySelectorAll(
      ".remove-viewed-product"
    );
    if (remainingProducts.length === 0) {
      this.animateHideSection();
    }
  }

  animateHideSection() {
    const section = document.querySelector("#recently-viewed-section");
    if (section) {
      section.style.transition = "opacity 0.3s ease";
      section.style.opacity = "0";
      setTimeout(() => {
        section.remove();
      }, 300);
    }
  }

  showSuccessMessage(message) {
    if (typeof window.toast !== "undefined") {
      window.toast.success(message);
    }
  }

  showErrorMessage(message) {
    if (typeof window.toast !== "undefined") {
      window.toast.error(message);
    }
  }
}

export default RecentlyViewedProducts;
